module.exports = __webpack_public_path__ + "img/copier.d6a9bb97.gif";